import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { isWindowVisible, setSocketContext } from './store/actions/socketAction';
import socket from './utils/socket';
import { roundNumber } from './utils/formatDecimal';
import LocalStorage from './utils/localStorage';
import { changeLocale } from './store/actions/settings';
import ErrorBoundary from './components/Errors/ErrorBoundary/ErrorBoundary';
import { removeMoreMarketsRedirectUrl, setDatePickerLocale } from './utils/helpers';
import { getMarketGroups } from './store/actions/markets';
import { IS_PROD, MARKET_GROUP_STATUSES } from './constants/defaultValues';
import { identifyLogRocketUser } from './utils/logrocket';
import AppVersion from './components/shared/Toasts/AppVersion/AppVersion';
import { fetchAppVersion } from './store/actions/global';
import SocketUpdater from './components/shared/SocketUpdater/SocketUpdater';
import { fetchTranslationsList } from './store/actions/translations';
import Routes from './Routes';
import TranslationModeBar from './components/TranslationModeBar/TranslationModeBar';
import deviceSocket from './utils/device-socket';
import LiveChatWidget from './components/LiveChatWidget/LiveChatWidget';

setDatePickerLocale();

removeMoreMarketsRedirectUrl();

// let reConnectTimer = null;

window.trimNum = (num, noMinus = true) => {
    // const trimmed = currJs(num).value;
    if (num < 0 && noMinus) return '0.00';
    return roundNumber(num, 2);
};

const App = props => {
    const dispatch = useDispatch();
    const { account, theme, locale } = useSelector(state => state.settings);

    const accountNumber = account?.data?.accountNumber;

    useEffect(() => {
        deviceSocket.emit('context.updated', { isProd: IS_PROD, language: locale });

        window.onfocus = () => {
            deviceSocket.emit('context.updated', { isProd: IS_PROD, language: locale });
            dispatch(isWindowVisible(true));
        };

        window.onblur = () => dispatch(isWindowVisible(false));

        // dispatch(fetchTranslationsList());

        const lang = LocalStorage.getItem('lang');

        if (lang) {
            dispatch(changeLocale(lang));
        }

        return () => {
            // if (!socketConnected) socket.close();
        };
    }, []);

    useEffect(() => {
        const id = account?.data?.id;

        identifyLogRocketUser(accountNumber, { id });

        dispatch(fetchAppVersion());

        if (accountNumber) {
            dispatch(getMarketGroups({ status: MARKET_GROUP_STATUSES.active }));

            const context = {
                client: 'cashier',
                cashierId: id,
                userId: accountNumber,
            };

            dispatch(setSocketContext(context));

            socket.connect();
        } else {
            socket.disconnect();
        }
    }, [accountNumber]);

    useEffect(() => {
        if (theme) {
            document.body.classList.add('theme-light');
        } else {
            document.body.classList.remove('theme-light');
        }
    }, [theme]);

    return (
        <Router>
            <ErrorBoundary>
                <TranslationModeBar />
                <AppVersion />
                <SocketUpdater />
                <Routes />
            </ErrorBoundary>
            {IS_PROD && <LiveChatWidget />}
        </Router>
    );
};

export default App;
